export const systemdApi = '/systemd-service-api';
export const rbacApi = '/rbac-service-api';
export const functionApi = '/function-service-api';
export const formApi = '/form-service-api';
export const bpmnApi = '/bpmn-service-api';
export const stencilApi = '/stencil-service-api';
export const webComponentsApi = '/web-components-service-api';
export const fileApi = '/file-api';
export const TEMPLATE_AST_EXPIRES = (window as any)?.web_components_config?.TEMPLATE_AST_EXPIRES;
export const PENPOT_EMAIL = (window as any)?.application_config?.PENPOT_EMAIL;
export const PENPOT_PASSWORD = (window as any)?.application_config?.PENPOT_PASSWORD;
export const PENPOT_URL = (window as any)?.application_config?.PENPOT_URL;
export const AI_API_URL = (window as any)?.application_config?.AI_API_URL;
export const SUPERSET_URL = (window as any)?.application_config?.VUE_APP_SUPERSET_URL + '/superset/sql_json/' ;
const ip = (window as any)?.application_config?.UPLOAD_URL;
export const AI_PAGE_ROUTING_URL = (window as any)?.application_config?.AI_PAGE_ROUTING_URL;
export const fileServerUrl = `${ip}/web-api/file-api`;
export const aiGenDesignApi = `/ai-api`
export const PLUGIN_DRAWDB_URL = (window as any)?.application_config?.PLUGIN_DRAWDB_URL;
export const PLUGIN_STATIC_ONTOLOGY_URL = (window as any)?.application_config?.PLUGIN_STATIC_ONTOLOGY_URL;
